import React from "react";
import useStrings from "../hooks/useStrings";

const Skills = ({ classicHeader, darkTheme }) => {
  const langStrings = useStrings();

  const programmingSkills = [
    { name: "Kotlin",      stars: 5 },
    { name: "Java",        stars: 4 },
    { name: "Spring Boot", stars: 4 },
    { name: "Jersey",      stars: 4 },
    { name: "Maven",       stars: 5 },
    { name: "Gradle",      stars: 4 },
    { name: "TypeScript",  stars: 4 },
    { name: "JavaScript",  stars: 4 },
  ];

  const databasesSkills = [
    { name: "Postgres",      stars: 5 },
    { name: "MySQL",         stars: 5 },
    { name: "Oracle",        stars: 4 },
    { name: "Oracle PL/SQL", stars: 4 },
  ];

  const devOpsSkills = [
    { name: "Git",        stars: 5 },
    { name: "Subversion", stars: 5 },
    { name: "Jenkins",    stars: 4 },
    { name: "Openshift",  stars: 4 },
    { name: "Grafana",    stars: 4 },
    { name: "Prometheus", stars: 4 },
    { name: "Gitlab",     stars: 4 },
  ];

  const otherSkills = [
    { name: "IT consulting",             stars: 4 },
    { name: "Database structure design", stars: 4 },
    { name: "Small team management",     stars: 4 },
    { name: "React JS",                  stars: 3 },
    { name: "HTML/CSS",                  stars: 5 },
    { name: "Angular JS",                stars: 3 },
    { name: "Web Design",                stars: 3 },
    { name: "Bootstrap",                 stars: 5 },
  ];

  const SkillsGroup = ({ title, skills }) => (
    <>
      <h2 className={"text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")}>
        {title}
      </h2>
      <div className="row gx-5">
        {skills.map((skill, index) => (
          <div key={index} className="col-md-6 d-flex justify-content-between align-items-center mb-3">
            <span className={"fw-500 " + (darkTheme ? "text-light" : "text-dark")}>
              {skill.name}
            </span>
            <span className="text-primary ms-2">
              {[1, 2, 3, 4, 5].map((i) => (
                <i
                  key={i}
                  className={i <= skill.stars ? "fas fa-star" : "far fa-star"}
                  style={{ fontSize: "0.75rem" }}
                />
              ))}
            </span>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <section
      id="skills"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24 text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            {langStrings.skillsTitle}
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {langStrings.skillsSubtitle}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end */}
        <SkillsGroup title={langStrings.skillsProgramming} skills={programmingSkills} />
        <SkillsGroup title={langStrings.skillsDatabases}   skills={databasesSkills} />
        <SkillsGroup title={langStrings.skillsDevOps}      skills={devOpsSkills} />
        <SkillsGroup title={langStrings.skillsOther}       skills={otherSkills} />
      </div>
    </section>
  );
};

export default Skills;
